import React from 'react';
import { FadeIn } from './FadeIn';
import { Award, Heart, ShieldCheck } from 'lucide-react';
export function AboutInstructor() {
  return <section id="about" className="py-24 bg-white overflow-hidden" data-id="element-14">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-15">
        <div className="flex flex-col lg:flex-row items-center gap-16" data-id="element-16">
          {/* Image Side */}
          <div className="w-full lg:w-1/2 relative" data-id="element-17">
            <FadeIn direction="right" data-id="element-18">
              <div className="relative rounded-2xl overflow-hidden shadow-2xl aspect-[4/5] max-w-md mx-auto lg:mx-0" data-id="element-19">
                <img src="https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?auto=format&fit=crop&q=80&w=1000" alt="Yoga Instructor" className="w-full h-full object-cover" data-id="element-20" />
                <div className="absolute inset-0 bg-gradient-to-t from-yoga-dark/60 to-transparent" data-id="element-21"></div>
                <div className="absolute bottom-0 left-0 right-0 p-8" data-id="element-22">
                  <p className="text-yoga-primary font-bold text-lg mb-1" data-id="element-23">
                    Lead Instructor
                  </p>
                  <h3 className="text-3xl font-bold text-white" data-id="element-24">Shree</h3>
                </div>
              </div>

              {/* Decorative elements */}
              <div className="absolute -z-10 top-10 -right-10 w-64 h-64 bg-yoga-lightest rounded-full blur-3xl opacity-60" data-id="element-25"></div>
              <div className="absolute -z-10 -bottom-10 -left-10 w-48 h-48 bg-yoga-primary/10 rounded-full blur-2xl" data-id="element-26"></div>
            </FadeIn>
          </div>

          {/* Content Side */}
          <div className="w-full lg:w-1/2" data-id="element-27">
            <FadeIn direction="left" data-id="element-28">
              <div className="flex items-center gap-4 mb-4" data-id="element-29">
                <div className="h-px w-12 bg-yoga-primary" data-id="element-30"></div>
                <span className="text-yoga-primary font-bold uppercase tracking-wider text-sm" data-id="element-31">
                  About The Instructor
                </span>
              </div>

              <h2 className="text-4xl md:text-5xl font-bold text-yoga-dark mb-6" data-id="element-32">
                Guiding you towards holistic wellness
              </h2>

              <p className="text-lg text-yoga-muted mb-6 leading-relaxed" data-id="element-33">
                With over a decade of experience in traditional and modern yoga
                practices, I founded Shree Yoga Fitness to create a sanctuary
                for physical and mental wellbeing in Pune. My approach blends
                ancient Indian wisdom with contemporary fitness science.
              </p>

              <blockquote className="border-l-4 border-yoga-primary pl-6 py-2 mb-8 bg-yoga-warm/50 rounded-r-lg" data-id="element-34">
                <p className="text-xl italic text-yoga-dark font-serif" data-id="element-35">
                  "Yoga is not about touching your toes, it's about what you
                  learn on the way down."
                </p>
              </blockquote>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-8" data-id="element-36">
                <div className="flex items-start gap-3" data-id="element-37">
                  <div className="p-2 bg-yoga-lightest rounded-lg text-yoga-primary shrink-0" data-id="element-38">
                    <Award className="w-6 h-6" data-id="element-39" />
                  </div>
                  <div data-id="element-40">
                    <h4 className="font-bold text-yoga-dark" data-id="element-41">
                      Certified Expert
                    </h4>
                    <p className="text-sm text-yoga-muted" data-id="element-42">
                      RYT 500 Yoga Alliance
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3" data-id="element-43">
                  <div className="p-2 bg-yoga-lightest rounded-lg text-yoga-primary shrink-0" data-id="element-44">
                    <Heart className="w-6 h-6" data-id="element-45" />
                  </div>
                  <div data-id="element-46">
                    <h4 className="font-bold text-yoga-dark" data-id="element-47">10+ Years</h4>
                    <p className="text-sm text-yoga-muted" data-id="element-48">
                      Teaching Experience
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3" data-id="element-49">
                  <div className="p-2 bg-yoga-lightest rounded-lg text-yoga-primary shrink-0" data-id="element-50">
                    <ShieldCheck className="w-6 h-6" data-id="element-51" />
                  </div>
                  <div data-id="element-52">
                    <h4 className="font-bold text-yoga-dark" data-id="element-53">
                      Holistic Approach
                    </h4>
                    <p className="text-sm text-yoga-muted" data-id="element-54">
                      Mind, Body & Spirit
                    </p>
                  </div>
                </div>
              </div>

              <a href="#contact" className="inline-flex items-center justify-center px-8 py-3 border border-yoga-primary text-yoga-primary font-bold rounded-full hover:bg-yoga-primary hover:text-white transition-colors" data-id="element-55">
                Connect with me
              </a>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}